import React, { useEffect, useState } from 'react';
import { Box, IconButton, Tooltip } from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import { revealClientValue } from 'api';
import useError from 'components/ErrorProvider/useError';
import { ClientSensitiveField } from 'interfaces';

interface IProps {
  masked: string | null | undefined;
  phone: string;
  field: ClientSensitiveField;
  roomGuid?: string | null;
}

// Маскированное ПДн карточки клиента: полное значение запрашивается по клику и живёт до закрытия карточки.
const SensitiveValue: React.FC<IProps> = ({ masked, phone, field, roomGuid }) => {
  const { addError } = useError();
  const [value, setValue] = useState<string | null>(null);
  const [shown, setShown] = useState(false);
  const [loading, setLoading] = useState(false);

  // компонент переиспользуется для разных клиентов (строка таблицы, смена телефона в карточке) —
  // раскрытое значение не должно «прилипать» к новым phone/field/roomGuid
  useEffect(() => {
    setValue(null);
    setShown(false);
  }, [phone, field, roomGuid]);

  if (!masked) {
    return <>-</>;
  }

  // без телефона раскрытие всегда упадёт 400 (@NotBlank на бэке) — кнопку не показываем
  if (!phone?.trim()) {
    return <>{masked}</>;
  }

  const toggle = (event: React.MouseEvent) => {
    event.stopPropagation();
    if (shown || value !== null) {
      setShown(!shown);
      return;
    }
    setLoading(true);
    revealClientValue(phone, field, roomGuid)
      .then((full) => {
        setValue(full || '-');
        setShown(true);
      })
      .catch((error) =>
        addError(
          error.response?.status === 403
            ? 'Нет доступа'
            : error.response?.data?.message || 'Не удалось показать значение',
        ),
      )
      .finally(() => setLoading(false));
  };

  return (
    <Box component="span" display="inline-flex" alignItems="center">
      {shown ? value : masked}
      <Tooltip title={shown ? 'Скрыть' : 'Показать'}>
        <span>
          <IconButton size="small" onClick={toggle} disabled={loading}>
            {shown ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  );
};

export default SensitiveValue;
